import { ShadowBox } from '@elements/Common';
import { Placeholder, PlaceholderLine } from 'semantic-ui-react';

export function PackagingDetailPlaceholder() {
  return (
    <div className="d-flex mt-2">
      <ShadowBox className="w-50 mr-2">
        <Placeholder>
          <PlaceholderLine />
          <PlaceholderLine />
          <PlaceholderLine />
          <PlaceholderLine />
          <PlaceholderLine />
        </Placeholder>
      </ShadowBox>
      <ShadowBox className="w-50 ml-2">
        <Placeholder>
          <PlaceholderLine />
          <PlaceholderLine />
          <PlaceholderLine />
          <PlaceholderLine />
          <PlaceholderLine />
        </Placeholder>
      </ShadowBox>
    </div>
  );
}
